import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'ratingClass',
  standalone: false
})
@Injectable()
export class RatingClassPipe implements PipeTransform {
  public transform(value: number, total: number): string {
    return `rating--${total}-${Math.floor(value)}`;
  }
}
